import React, { Component } from 'react';

class MiniCarousel extends Component {

    render() {
        let slidesPerPage = this.props['slidesPerPage'] ? this.props['slidesPerPage'] : 1;
        let slidesScroll = this.props['slidesScroll'] ? this.props['slidesScroll'] : 1;
        return (
            <div className="js-carousel g-pb-45"
                data-autoplay="true"
                data-infinite="true"
                data-slides-show={slidesPerPage}
                data-slides-scroll={slidesScroll}
                data-speed="4000"
                data-pagi-classes="u-carousel-indicators-v1 g-absolute-centered--x text-center g-bottom-20"
                data-responsive='[{
                    "breakpoint": 1200,
                    "settings": {
                    "slidesToShow": 4
                    }
                }, {
                    "breakpoint": 992,
                    "settings": {
                    "slidesToShow": 3
                    }
                }, {
                    "breakpoint": 768,
                    "settings": {
                    "slidesToShow": 2
                    }
                }, {
                    "breakpoint": 576,
                    "settings": {
                    "slidesToShow": 1
                    }
                }]'>

                {this.props.content && this.props.content.map((item, key) =>
                    <div key={key} className="js-slide g-brd-gray-light-v4 rounded g-pa-20 g-mx-10">
                        <img className="img-fluid mx-auto" src={item.img} alt={item.title} />
                    </div>)
                }
            </div>
        );
    }
}

export default MiniCarousel;


// WEBPACK FOOTER //
// ./src/subcomponents/MiniCarousel.js